import React from "react";
import { Chart as ChartJS, BarElement, BarController, LinearScale, CategoryScale, Title, Tooltip, Legend } from "chart.js";
import { Bar } from 'react-chartjs-2';

ChartJS.register(BarElement, BarController, LinearScale, Title, CategoryScale, Tooltip, Legend);

const options = {
    scales: {
        yAxes: [
            {
                ticks: {
                    beginAtZero: true,
                },
            },
        ],
    },
    plugins: {
        legend: {
            display: false
        }
    }
};

const ActivityWeeklyChart = ({label, data}) => {

    const dataSet = {
            labels: ['Sun','Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            datasets: [
                {
                    label: label,
                    data: data,
                    backgroundColor: [
                        'rgba(140, 46, 88, .25)',
                        'rgba(140, 46, 88, .5)',
                        'rgba(140, 46, 88, .5)',
                        'rgba(140, 46, 88, .5)',
                        'rgba(140, 46, 88, .5)',
                        'rgba(140, 46, 88, .5)',
                        'rgba(140, 46, 88, .25)',
                    ],
                    borderColor: [
                        '#5B002F',
                    ],
                    borderWidth: 2,
                },
            ],
        };

    return (
            <Bar data={dataSet} options={options} type="bar" />
    )
}

export default ActivityWeeklyChart;
